import { useMediaQuery } from 'usehooks-ts';

/**
 * Detects if the device is touch-enabled.
 *
 * - `primaryOnly` = true → only returns true if the *primary* input is touch
 *   (e.g. iPhone, iPad, Android).
 * - `primaryOnly` = false → returns true if *any* touch input is available
 *   (e.g. Surface laptop with touchscreen + mouse).
 */
export const useIsTouchDevice = (primaryOnly = true): boolean => {
  const query = primaryOnly ? '(pointer: coarse) and (hover: none)' : '(any-pointer: coarse)';

  return useMediaQuery(query);
};
